import { Injectable } from '@angular/core';
import { IntegrationType, INTEGRATION_CATEGORY, IS_NOT_EMPTY, User } from 'cargo-chief-commons';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Cargochief } from '../cargochief/cargochief.service';

@Injectable({
	providedIn: 'root',
})
export class AccessCacheService {
	constructor(private cargochief: Cargochief) {}

	getAccountUsers(): User[] {
		let users: User[] = [];
		const usersString: string = this.cargochief.getItem(CARGOCHIEF_KEYS.ACCOUNT_USERS);
		if (IS_NOT_EMPTY(usersString)) {
			users = JSON.parse(usersString);
		}
		return users;
	}

	getIntegrationTypes({ category }: { category: INTEGRATION_CATEGORY }): IntegrationType[] {
		let integrationTypes: IntegrationType[] = [];
		const integrationTypesString: string = this.cargochief.getItem(
			CARGOCHIEF_KEYS.INTEGRATION_TYPES
		);
		if (IS_NOT_EMPTY(integrationTypesString)) {
			integrationTypes = JSON.parse(integrationTypesString);
			integrationTypes = integrationTypes.filter(
				(integrationType: IntegrationType) => integrationType.category == category
			);
		}
		return integrationTypes;
	}
}
